




















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BaseDocument, JinroRoomDocument } from "@/services/datatypes";
import JinroRoom from "../../views/JinroRoom.vue";
import { JinroRoomStatus } from "../../services/jinro-room-status";

@Component
export default class ListView extends Vue {
  @Prop() readonly refCollection!: firebase.firestore.CollectionReference;
  @Prop() readonly path!: string;
  detacher?: firebase.Unsubscribe;
  articles: Array<JinroRoomDocument> | null = null;

  created() {
    this.detacher = this.refCollection
      .orderBy("timeCreated", "desc")
      .where("owner", "==", this.$store.state.firebaseUser.uid)
      .onSnapshot((snapshot) => {
        const jinroRooms = snapshot.docs.map((doc) => {
          return Object.assign(doc.data(), { id: doc.id }) as JinroRoomDocument;
        });
        this.articles = jinroRooms.filter((jinroRoom) => {
          return !jinroRoom.isDeleted || !jinroRoom.isDeleted;
        });

        this.$emit("jinro-rooms-length", this.articles.length);
      });
  }
  destroyed() {
    this.detacher && this.detacher();
  }

  isPlaying(jinroRoom: JinroRoomDocument): boolean {
    if (!jinroRoom || !jinroRoom.jinroRoomStatus) {
      return false;
    }
    return jinroRoom.jinroRoomStatus === JinroRoomStatus.Playing;
  }
}
